// Styles
import PortfolioLiveContainer from "./PortfolioLive.styles";
import PowerBIDashboard from "../../components/Common/PowerBIDashboard";
import React from "react";

type Props = {};

export default function PortfolioLive({}: Props) {
    return (
        <PortfolioLiveContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="e802e0b1-0278-466f-8d50-21987b53dc5f"
                    workspaceId="c9679fac-e043-4b12-b47b-d350f81543c1"
                ></PowerBIDashboard>
            </div>
        </PortfolioLiveContainer>
    );
}
